import { Stack } from '@mui/material';
import colors from '../../colors/colors';
import { RxCross1 } from "react-icons/rx";
import { useDispatch} from 'react-redux';
import { changeCurrentErrorMessage } from '../../redux/actions';


export default function Error(props: any) {
    const dispatch = useDispatch();
    const error = props.error;

    return (
        <Stack bgcolor={colors.pink} py={1.5} px={1.5} borderRadius={0.5} my={2}>
            <Stack width={"100%"} alignItems={"end"}>
                <RxCross1 className='cursor-pointer' color='white' onClick={() => dispatch(changeCurrentErrorMessage(null))} />
            </Stack>
            <p className='m-0 century text-white align-center'>{error}</p>
        </Stack>
    );
};